
/**
 * Obtém o `eref` da workspace associada ao paper.
 * @pathErefOrPaper {String | Keep.Paper.Design.Paper}
 *    O eref do Paper ou o próprio Paper.
 */
export function workspaceFor(link) {

  // TODO:  Algoritmo de descoberta da WORKSPACE de um PAPER.
  //        É necessário uma forma melhor.
  //        Por ora estamos usando a primeira parte do EREF como nome da WORKSPACE.
  //        Exemplo:
  //            Para: `Replicacao.Tickets.Destinatarios`
  //            Extraimos a WORKSPACE: `Replicacao.Workspace`
  //        O ideal seria as WORKSPACEs contextuais descerem no próprio PAPER.
  //        Exemplo:
  //            Para: `Replicacao.Tickets.Destinatarios`
  //            Teríamos estes WORKSPACES contextuais:
  //                `Replicacao.Tickets.Workspace` -- Primário
  //                `Replicacao.Workspace` -- Alternativo

  const eref = link?.eref || link
  const prefix = eref?.split('.')?.[0]
  const workspace = `${prefix || 'Index'}.Workspace`

  // const eref = (link?.eref || link || "").replace(".Workspace", "")
  // const tokens = eref.split('.')
  // tokens.pop(); // Removendo a última parte do link...
  // const prefix = tokens.join('.')
  // const workspace = prefix ? `${prefix}.Workspace` : "Index.Workspace"

  return workspace
}
